// StoreContent.js
import React, { useState, useEffect, useRef } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  Badge,
  Input
} from "reactstrap";
import { withTranslation } from "react-i18next";

import { Link, useParams, useNavigate, useLocation } from 'react-router-dom';
import { getLastPage } from 'utils/history';

import { Star, Dot, ArrowLeftFromLine, UserMinus, UserPlus } from 'lucide-react';

import './StoreContent.css';
import VipBadge from "../../components/VipBadge";
import CardCarousel from './components/StoreContentTopicCardCarousel';
import ExperienceBar from "./components/ExperienceBar";

import { uploadImage, fetchImage } from "utils/images/imageManager";

import { useSelector, useDispatch } from "react-redux";
import { selectTopicsForStore } from "store/selectors";

import home4 from 'assets/images/info/home4.png';
import placeholder_image from "assets/images/info/card-placeholder-medium.png";

import axiosInstance from "utils/axiosInstance";


/* Store Profile Viewers */
const StoreContent = ({ t }) => {

  const { storeId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();


  //--------------------------------------------------
  // States
  //--------------------------------------------------

  //const [myInfoProfile, setMyInfoProfile] = useState({});
  //const [myInfoTopics, setMyInfoTopics] = useState([]);
  //const [profileBackgroundUrl, setProfileBackgroundUrl] = useState("");
  const [isBackgroundUrlLoaded, setIsBackgroundUrlLoaded] = useState(false);
  //const [profileImageUrl, setProfileImageUrl] = useState("");
  const [isProfileUrlLoaded, setIsProfileUrlLoaded] = useState(false);

  //const [imageMap, setImageMap] = useState(new Map());
  //const [levelData, setLevelData] = useState({});

  const [profileLoading, setProfileLoading] = useState(true);
  const [dataFetchError, setDataFetchError] = useState(null);

  const handlePageBack = () => {

    // Last=Store Topic >> Back=Store Menu
    // Last=Store Menu >> Back=Store Menu

    const last = getLastPage();
    console.log('previous page:', last);
    if (last==="/myInfo/storeMenu") {
      navigate(last);
    } else {
      navigate(`/myInfo/storeMenu`, { state: { __restoreScroll: true } });
    }

  };


  
  const {
    storeData,
    loading: storeDetailsLoading,
    error: storeDetailsError,
  } = useSelector(state => ({
    storeData: state.storeDetails.stores[storeId] || {},
    loading: state.storeDetails.loading,
    error: state.storeDetails.error,
  }));

  const imageMap = useSelector(state => state.imageMap);

  useEffect(() => {
    dispatch({ type: 'STORE_DETAILS_FETCH_REQUEST', storeId });
  }, [storeId]);

  const {
    profile: myInfoProfile,
    levelData
  } = storeData;
  const myInfoTopics = useSelector(state => selectTopicsForStore(state, storeId));

  const profileImageUrl = myInfoProfile?.profileImage;
  const profileBackgroundUrl = myInfoProfile?.backgroundImage;

  useEffect(() => {
    console.log('profileImageUrl:', profileImageUrl);
  }, [profileImageUrl]);


  useEffect(() => {
    console.log('storeData:', storeData);
  }, [storeData]);

  useEffect(() => {
    console.log('myInfoTopics:', myInfoTopics);
  }, [myInfoTopics]);

  //--------------------------------------------------
  // Load store info and topics on mount
  //--------------------------------------------------

  /*
  const fetchData = async () => {
    try {
      setProfileLoading(true);
      setDataFetchError(null);

      // Load Store Info and Custom Topics
      const [profileResponse, topicResponse, expResponse] = await Promise.all([
        axiosInstance.get(`/knovia/myInfo/stores/${storeId}/storeInfoProfile`),
        axiosInstance.get(`/knovia/myInfo/stores/${storeId}/getTopicsInStore`),
        axiosInstance.get(`/knovia/myInfo/stores/${storeId}/experience`)
      ]);

      console.log('Profile Loaded:', profileResponse.data);
      setMyInfoProfile(profileResponse.data);

      console.log('User Topics Loaded:', topicResponse.data);
      // Sort by `order` before setting state
      const sortedTopics = [...topicResponse.data].sort(
        (a, b) => a.order - b.order
      );
      setMyInfoTopics(sortedTopics);

      console.log('User Experience in store Loaded:', expResponse.data);
      setLevelData(expResponse.data);

      return {
        profile: profileResponse.data,
        topics: sortedTopics
      };
    } catch (err) {
      console.error(err);
      setDataFetchError("Failed to load data.");
      return null; // <- This ensures the caller knows the fetch failed
    } finally {
      setProfileLoading(false);
    }
  };

  const fetchProfileImages = async (profile) => {
    try {
      const backgroundPromise = profile?.backgroundImage
        ? fetchImage(profile.backgroundImage, "original")
        : Promise.resolve(null);

      //if (!profile?.backgroundImage) { setIsBackgroundUrlLoaded(true); }

      const profilePromise = profile?.profileImage
        ? fetchImage(profile.profileImage, "original")
        : Promise.resolve(null);

      if (!profile?.profileImage) { setIsProfileUrlLoaded(true); }

      const [backgroundUrl, profileImgUrl] = await Promise.all([
        backgroundPromise,
        profilePromise,
      ]);

      setIsBackgroundUrlLoaded(true);
      setIsProfileUrlLoaded(true);

      if (backgroundUrl) setProfileBackgroundUrl(backgroundUrl);
      if (profileImgUrl)  setProfileImageUrl(profileImgUrl);
    } catch (err) {
      console.error("Error fetching profile images:", err);
    }
  };

  const fetchTopicImages = async (topics) => {
    const newMap = new Map(imageMap); // preserve existing

    await Promise.all(
      topics.map(async (entry) => {
        const filename = entry.image;
        if (!filename || newMap.has(filename)) return;

        try {
          const url = await fetchImage(filename, "original");
          newMap.set(filename, url);
        } catch (e) {
          console.error("Failed to load image:", filename);
        }
      })
    );
    setImageMap(newMap);

  };

  const loadInfoProfileData = async () => {
    const dataFetched = await fetchData();
    if (!dataFetched) return;

    const { profile, topics } = dataFetched;

    if(profile) {
      fetchProfileImages(profile);
    }
    if(topics) {
      fetchTopicImages(topics);
    }
  }

  useEffect(() => {
    loadInfoProfileData();
  }, []);
  */


  //--------------------------------------------------
  // Follow and Unfollow
  //--------------------------------------------------
  
  const handleFollow = async () => {
    try {
      const response = await axiosInstance.post(`/knovia/myInfo/stores/${storeId}/follow`);
      dispatch({
        type: 'UPDATE_FOLLOW_STATUS',
        payload: {
          storeId,
          isFollowing: true,
          followerCount: (myInfoProfile?.followerCount || 0) + 1
        }
      });
      console.log("Follow successful:", response.data);
    } catch (error) {
      if (error.response?.status === 409) {
        console.log("Already followed.");
      } else {
        console.error("Failed to follow store:", error);
      }
    }
  };

  const handleUnfollow = async () => {
    try {
      const response = await axiosInstance.delete(`/knovia/myInfo/stores/${storeId}/unfollow`);
      dispatch({
        type: 'UPDATE_FOLLOW_STATUS',
        payload: {
          storeId,
          isFollowing: false,
          followerCount: Math.max((myInfoProfile?.followerCount || 1) - 1, 0)
        }
      });
      console.log("Unfollowed successfully:", response.data);
    } catch (error) {
      console.error("Failed to unfollow:", error);
    }
  };


  //--------------------------------------------------
  // Return
  //--------------------------------------------------

  return (

    <div className="page-content store-content" 
      style={{ "--page-content-background": `url(${home4})` }}
    >

      <Container fluid className="store-content-container">

        <div className="d-block d-md-none">
          {/* Profile Image at top */}
          <div 
            /*className={`store-content-top-image ${isBackgroundUrlLoaded ? 'fade-in' : ''}`}*/
            className={`store-content-top-image`}
            style={{
              backgroundImage: `url(${imageMap[profileBackgroundUrl] || placeholder_image})`,
            }}
          >
          </div>

          <div className="store-content-page-back-div">
            <Button
              style={{
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "5px",
                boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                background: "#55535373"
              }}
              onClick={handlePageBack}
            >
              <ArrowLeftFromLine size={24} />
            </Button>
          </div>
        </div>

        <Card className="store-content-card">
          <CardBody className="store-content-card-body">


            {/*------ Small Screen ------*/}
            <div className="d-block d-md-none">

              <div 
                /*className={`store-content-profile-thumbnail ${isProfileUrlLoaded ? 'fade-in' : ''}`}*/
                className={`store-content-profile-thumbnail`}
                style={{
                  backgroundImage: `url(${imageMap[profileImageUrl] || placeholder_image})`,
                }}
              >
              </div>

              {/* Store Name Label */}
              <Row className="mb-1">
                <Col className="store-content-label">
                  <p className="mb-0">{myInfoProfile?.displayName}</p>
                </Col>
              </Row>

              {/* Store Description Bio */}
              {myInfoProfile?.bio && (
                <Row>
                  <Col className="store-content-bio">
                    <p className="mb-0" style={{ fontSize: "13.5px", color: "#848282" }}>
                      {myInfoProfile?.bio}
                    </p>
                  </Col>
                </Row>
              )}

              {/* Star and VIP level */}
              <Row>
                <Col className="store-content-star-col">
                  <div style={{ marginTop: "-6px" }}>
                    <VipBadge vipLevel="VIP1" imageSize={35} textSize={42} />
                  </div>
                </Col>
              </Row>

              <Row style={{ marginBottom: "20px" }}>
                <Col className="store-content-filled-count-col">
                  <Button color="soft-success" style={{
                    height: "30px",
                    paddingTop: "3.5px"
                  }}>
                    {myInfoProfile?.followerCount || 0}+ 人已追蹤
                  </Button>
                </Col>
              </Row>

            </div>


            {/* Follow */}
            <div className="d-flex justify-content-center" style={{ marginBottom: "30px" }}>
              <div className="d-flex flex-column align-items-center"
                style={{ cursor: "pointer", userSelect: "none" }}
                onClick={myInfoProfile?.isFollowing ? handleUnfollow : handleFollow}
              >
                {myInfoProfile?.isFollowing ? (
                  <>
                    <UserMinus size={32} strokeWidth={1.5} />
                    <p className="mb-0" style={{ marginTop: "1px" }}>取消追蹤用戶</p>
                  </>
                ) : (
                  <>
                    <UserPlus size={32} strokeWidth={1.5} />
                    <p className="mb-0" style={{ marginTop: "1px" }}>追蹤用戶</p>
                  </>
                )}
              </div>
            </div>

            <div className="w-100 d-flex justify-content-center">
              {levelData?.currentLevel && (
                <ExperienceBar 
                  levelData={levelData}
                />
              )}
            </div>


            <div className="section-div" />

            {/*------ Small Screen ------*/}
            <div className="d-block d-md-none">
              {/* QuestionSet Carousel */}
              <Row>
                <Col className="store-content-carousel-col">
                  <div className="d-flex justify-content-between" style={{ paddingLeft: "25px"}}>
                    <p className="mb-0 store-content-section-title">主題列表</p>
                  </div>
                  <CardCarousel 
                    cards={myInfoTopics}
                    imageMap={imageMap}
                  />
                </Col>
              </Row>

              <div className="section-div" style={{ margin: "30px 0px 0px 0px" }}/>
            </div>

          </CardBody>
        </Card>

      </Container>
    </div>
  );
};

export default withTranslation()(StoreContent);


